<template>
	<div ref="map" class="map" :hidden="!$mq.isDesktop()"/>
</template>


<script type="text/javascript">
import { debounce } from '../../assets/js/main'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from '../../store/orderStore'

import Vue from 'vue'

export default {
	data () {
		return {
			icons: {
				black: 'https://www.google.com/mapfiles/marker_black.png',
				green: 'https://www.google.com/mapfiles/marker_green.png'

			},

			deliveryStore: deliveryStore.state,

			centerMapDefault: {
				lat: 45.4647124,
				lng: 9.1906922
			}
		}
	},
	props: {
		points: {
			Type: Array,
			default () {
				return null
			}
		},
		currentZip: {
			type: String,
			default: null
		},
		selectedPointId: {
			Type: Number,
			default: null
		}
	},
	watch: {
		points () {
			if (!this.points) return

			this.filterMarkers()
		},

		currentZip () {
			if (this.currentZip && this.currentZip.length >= 5) {
				this.getCoordinates({ zip_code: this.currentZip })
			}
		},

		address () {
			this.findCurrentPoint()
		},
	},

	computed: {
		user () {
			return this.$root.user
		},

        delivery () {
            var sub = this.user && this.user.subscription
            return sub && this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        }
	},

	methods: {	
		initMap () {
			this.allMarkers = []
			this.map = new google.maps.Map(this.$refs.map, { zoom: 13, center: this.centerMapDefault })
			// this.filterMarkers()
			this.addMapListener()	
		},

		addMapListener () {	
			this.debouncedGetViewportCoordinated = debounce( () => {
				this.getViewportCoordinates({ map: this.map })
			}, 100)

			google.maps.event.addListener(this.map, 'idle', () => {
				this.debouncedGetViewportCoordinated()
			})
		},

		getViewportCoordinates (params) {
			var map = params.map

        	var lat0 = map.getBounds().getNorthEast().lat()
			var lng0 = map.getBounds().getNorthEast().lng()
			var lat1 = map.getBounds().getSouthWest().lat()
			var lng1 = map.getBounds().getSouthWest().lng()

			// if map is hidden
			if (lat0 === lat1 && lng0 === lng1) {
				var radius = 0.05
				lat0 = lat0 + radius
				lat1 = lat1 - radius
				lng0 = lng0 + radius
				lng1 = lng1 - radius
			}

			var viewpoint = {
				lat0: lat0,
				lat1: lat1,
				lng0: lng0,
				lng1: lng1
			}

			this.$emit('onViewpointUpdate', viewpoint)
		},

		filterMarkers() {
			this.allMarkers.forEach(marker => marker.setMap(null))
			this.allMarkers = []

			this.findCurrentPoint()
			
		},

		findCurrentPoint () {
			if (!this.points) return
			this.points.forEach(point => {
				this.addMarker(point)
				if (!this.selectedPointId && this.delivery && this.delivery.code === point.code) {
					this.$emit('update:selectedPointId', point.id) 
					this.selectMarker(point.id, point)
					this.$emit('onSelectPoint')
				}
				if (point.id === this.selectedPointId) this.selectMarker(point.id, point)
			})
		},

		geolocate () {	
			var map = this.map
			var infoWindow = new google.maps.InfoWindow

			function handleLocationError(browserHasGeolocation, infoWindow, pos) {
		        infoWindow.setPosition(pos)
		        infoWindow.setContent(browserHasGeolocation ?
					'Error: The Geolocation service failed.' :
					'Error: Your browser doesn\'t support geolocation.')
		        infoWindow.open(map)
		    }

			if (navigator.geolocation) {
				return new Promise((resolve, reject) => {
		         	navigator.geolocation.getCurrentPosition((position) => {
			            var pos = {
			             	lat: position.coords.latitude,
			            	lng: position.coords.longitude
			            }

		            	infoWindow.setPosition(pos)
		            	infoWindow.setContent('Sei qui')
		            	infoWindow.open(map)
		            	map.setCenter(pos)

						return resolve(pos)

					}, function() {
		            	handleLocationError(true, infoWindow, map.getCenter())
		            	return reject(new Error())
		          	})
		        })
	        } else {
	        	// Browser doesn't support Geolocation
	        	handleLocationError(false, infoWindow, map.getCenter())
	        	return reject(new Error())
	        }
		},

		addMarker (point) {
			if (!point.address['geolocation']) return
			var resultsMap = this.map

			var lat = point.address['geolocation'].latitude
        	var lng = point.address['geolocation'].longitude

        	var position = { lat: lat, lng: lng }
	                
        	var marker = new google.maps.Marker({
          		map: resultsMap,
         		position: position
        	})

        	marker.setIcon(this.icons.black)
        	marker.myId = point.id
        	marker.myPosition = new google.maps.LatLng(lat, lng)

        	this.allMarkers.push(marker)

	    	marker.addListener('click', () => {
	    		this.selectPoint(marker, point)
		    })
		},

		selectPoint (marker, point) {
			this.selectMarker(marker.myId, point)
    		this.$emit('update:selectedPointId', marker.myId)
    		this.$emit('onSelectPoint')
		},

		selectMarker (markerId, point) {
			this.allMarkers.forEach(marker => marker.setIcon(this.icons.black))
	        var marker = this.allMarkers.find(marker => marker.myId === markerId)

	        marker.setIcon(this.icons.green)

	        if (this.infowindow) {
        		this.infowindow.close()
    		}

	        var contentString = ''
	       	contentString += `<b>${point.name ? point.name : 'FermoPoint'}<br></b>`
			if (point.address.street) contentString += `${point.address.street}<br>`
			if (point.address.zip_code) contentString += `${point.address.zip_code} `
			if (point.address.city) contentString += `${point.address.city}`

			this.infowindow = new google.maps.InfoWindow({
				content: contentString,
				disableAutoPan: true
			})                  

		    this.infowindow.open(this.map, marker)
		},

		getCoordinates (params) {
			if (!params) return
			var lat = this.centerMapDefault.lat
			var lng = this.centerMapDefault.lng

			Vue.$geocoder.setDefaultMode('address')    // this is default
			Vue.$geocoder.send({ zip_code: params.zip_code }, response => {
				if (response.status === 'OK') {
				    lat = response.results[0].geometry.location.lat
					lng = response.results[0].geometry.location.lng
					
					var bounds0 = new google.maps.LatLng(response.results[0].geometry.bounds.northeast.lat, response.results[0].geometry.bounds.northeast.lng)
					var bounds1 = new google.maps.LatLng(response.results[0].geometry.bounds.southwest.lat, response.results[0].geometry.bounds.southwest.lng)
					// this.map.fitBounds(bounds)
				} else {
					console.log('geocoding doesn\'t work')
				}
				if (lat && lng) {
					this.map.setCenter({ lat: lat, lng: lng })
				} 
				if (bounds0 && bounds1) {
					var bounds = new google.maps.LatLngBounds()
				    bounds.extend(bounds0);
				    bounds.extend(bounds1);
				    this.map.fitBounds(bounds);
				}

			})
		}
	},

	mounted () {
		this.initMap()
	}
}
</script>

<style scoped>
.map {
	position: relative;
	height: 442px;
}
</style>